<template>
  <div class="serviceStore"  style=" margin-top:310px;">
    <div class="z_md" >
      <div class="one">
        <img src="../assets/md.jpg" alt="澳门极草销售门店">
      </div>
      <div class="two">
        <h3>門店正在上傳中……敬請期待！</h3>
        <p>澳門、香港加盟合作，請致電 +86 400-888-9991</p>
      </div>
    </div>
    <!--导航-->
    <Nav :titles="titles" :titleChild="titleChild" :navState="navState" :tipsState="tipsState"/>
  </div>
</template>

<script>
  import Nav from '@/components/Nav'
export default {
  name: 'ServiceStore',
  components:{
     Nav
  },
  data () {
    return {
      tipsState:false,
      navState:true,
      titles: '服務門店',
      titleChild:[{name:'銷售門店',src:'ServiceStore'},{name:'咨詢服務門店',src:'CounsellingStore'}]
    }
  },
  created(){
    window.scrollTo(0,0)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.serviceStore{
  .z_md{
    width: 860px;
    margin: 0 auto;
    margin-top: 140px;
    margin-bottom: 180px;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    .one{
      width: 309px;
    }
    .two{
      width: 546px;
      float: right;
      margin-top: 58px;
      h3{
        font-size: 28.68px;
        color: #0072b9;
        margin-bottom: 12px;
      }
      p{
        font-size: 21.51px;
        color: #9a9a9a;
        margin-top: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ServiceStore.vue